import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { RecoveryScreenTabBarFlags } from '../../mocks/showcase-mock-core'

/**
 * The read-only screen frame shared by the Recovery, Backup and Banner previews: the
 * production tab strip, its action buttons, and the optional auto-refresh bar.
 * Everything below (sub-tabs, status bar, notices, resource table) is projected,
 * because only the Recovery preview renders the first three.
 */
@Component({
  selector: 'showcase-screen-preview',
  templateUrl: './showcase-screen-preview.component.html',
  styleUrls: ['./showcase-screen-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseScreenPreviewComponent {
  @Input({ required: true }) flags!: RecoveryScreenTabBarFlags
  @Input({ required: true }) activeTab!: 'backup' | 'recovery'
  @Input() showRefreshBar = false
  @Input() ariaLabel = 'Screen preview (read-only)'
  // Set when an outer wrapper already draws the frame (the banner preview), so the
  // two borders don't nest.
  @Input() frameless = false
}
